/* ================================
   PRODUCT PAGE INTERACTIONS
================================ */

document.addEventListener("DOMContentLoaded", () => {

  /* ================================
     HEADER + TITLE OBSERVERS
  ================================ */

  const header = document.querySelector("header"); 
  const mediaWrapper = document.querySelector(".product__media-wrapper");
  const descTarget = document.querySelector(".product-description-featured-images");

  if (mediaWrapper && header) {
    new IntersectionObserver(([entry]) => {
      header.classList.toggle(
        "transparent-header",
        entry.isIntersecting
      );
    }, { threshold: 0.1 }).observe(mediaWrapper);
  }

  if (descTarget && header) {
    new IntersectionObserver(([entry]) => {
      header.classList.toggle(
        "desc-p-info",
        entry.isIntersecting
      );
    }, { threshold: 0.1 }).observe(descTarget);
  }

  /* ================================
     SPORTSWEAR VARIANT & COLOR MODALS
  ================================ */

  const spvBg    = document.querySelector(".spv-bg");
  const variantC = document.querySelector(".sportswear-varint-container");
  const variantT = document.querySelector(".transition-transform");
  const colorC   = document.querySelector(".sportswear-color-container");
  const colorT   = document.querySelector(".transition-transform1");

  const closeAll = () => {
    [spvBg, variantC, variantT, colorC, colorT].forEach(el => {
      el?.classList.remove("spv-up");
    });
  };

  document.querySelectorAll(".cust-seatches-title").forEach(el => {
    el.addEventListener("click", () => {
      const isActive = variantC?.classList.contains("spv-up");
      closeAll();
      if (!isActive) {
        [spvBg, variantC, variantT].forEach(el => el?.classList.add("spv-up"));
      }
    });
  });

  document.querySelectorAll(".t-p-container").forEach(el => {
    el.addEventListener("click", () => {
      const isActive = colorC?.classList.contains("spv-up");
      closeAll();
      if (!isActive) {
        [spvBg, colorC, colorT].forEach(el => el?.classList.add("spv-up"));
      }
    });
  });

  spvBg?.addEventListener("click", closeAll);

  /* ================================
     HIDE H1 WHEN MODAL OPEN
  ================================ */

  const h1 = document.querySelector(".t-p-container-content > h1");

  const checkSPV = () => {
    const open = [colorC, variantC, spvBg].some(
      el => el?.classList.contains("spv-up")
    );
    if (h1) h1.style.opacity = open ? "0" : "";
  };

  document.addEventListener("click", () => {
    setTimeout(checkSPV, 50);
  });

  checkSPV();

  /* ================================
     SIZE HEADING UPDATE
  ================================ */

  const sizeHeading = document.getElementById("size-heading");
  const infoContainer = document.querySelector(
    ".sportswear.product .product__info-container"
  );

  infoContainer?.addEventListener("click", e => {
    const label = e.target.closest("label");
    if (!label?.closest(".product-form__input")) return;

    setTimeout(() => {
      const input = label
        .closest(".product-form__input")
        ?.querySelector("input[type='radio']:checked");

      if (input && sizeHeading) {
        sizeHeading.innerHTML = `
          Size: ${input.value}
          <svg class="transition-transform" width="7" height="6" viewBox="0 0 7 6">
            <path d="M6.5 1.5L3.5 4.5L0.5 1.5" stroke="black"/>
          </svg>
        `;
      }
    }, 50);
  });

  /* ================================
     PRODUCT TITLE FADE ON SCROLL
  ================================ */

  const title = document.querySelector(
    ".sportswear.product .t-p-container.product__title h1"
  );

  if (mediaWrapper && title) {
    window.addEventListener("scroll", () => {
      const { top, height } = mediaWrapper.getBoundingClientRect();
      title.style.opacity = (-top > height * 0.1) ? "0" : "1";
    }, { passive: true });
  }

});


/* ================================
   PREVENT iOS DOUBLE TAP ZOOM
   (USE CAREFULLY)
================================ */

document.addEventListener("touchstart", e => {
  if (e.touches.length > 1) e.preventDefault();
}, { passive: false });

let lastTouchEnd = 0;
document.addEventListener("touchend", e => {
  const now = Date.now();
  if (now - lastTouchEnd <= 300) e.preventDefault();
  lastTouchEnd = now;
}, false);
